import { useCallback, useEffect, useRef } from 'react';
import '../../../styles/view-management.css';
import { useSelectedView } from '../../Charts/hooks/use-selected-view';
import useSyncView from '../hooks/use-sync-view';
import ViewDropdown, { type ViewDropdownRef } from './view-dropdown';

export interface ManageViewsModalProps {
  visible: boolean;
  onClose: () => void;
  viewSaved?: () => void;
}

export const ViewHandlerComponent = () => {
  const { viewOptions, updateView, isFetchingViews } = useSyncView();
  const ref = useRef<ViewDropdownRef>(null);
  const currentView = useSelectedView();

  useEffect(() => {
    if (currentView?.id) {
      ref.current?.setSelectedView(currentView.id);
    }
  }, [currentView?.id]);

  const updateSelectedView = useCallback(
    (viewId?: string) => {
      if (viewId) {
        ref.current?.setSelectedView(viewId);
        updateView(viewId);
      }
    },
    [updateView]
  );

  if (isFetchingViews) return null;

  return (
    <>
      <div className="ml-2 flex flex-row items-end gap-2">
        <ViewDropdown viewOptions={viewOptions} updateSelectedView={updateSelectedView} ref={ref} />
      </div>
    </>
  );
};
